import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";
import { slThemeLight } from "../slTheme";

export interface TrendArrowProps
{
    styles: Record<string, string>;
    slope: number;
    delta: number;
}

export interface TrendArrowState
{
}

const useStyles = makeStyles(
    {
        blueFill: { fill: 'blue' },
        blueLine: {
            fill: 'none',
            stroke: 'blue',
            strokeMiterlimit: 10,
            strokeWidth: '3px'
        },
        delta:
        {
            fontSize: slThemeLight.fontSizeBase600,
        },
    });


export class TrendArrowWithoutStyles extends React.Component<TrendArrowProps, TrendArrowState>
{
    render()
    {
        const rotations = [0, 15, 30, 45, 60, 75];
        const rotationIndex = Math.min(Math.floor(Math.abs(this.props.slope) * rotations.length), rotations.length - 1);

        const rotation = this.props.slope > 0 ? rotations[rotationIndex] : -rotations[rotationIndex];
        const transform = `rotate(${rotation} 8 8)`;
        return (
            <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" className={this.props.styles.trendArrow}>
                    <g transform={transform}>
                        <line className={this.props.styles.blueLine} x1=".03" y1="7.87" x2="11.17" y2="7.87"/>
                        <path className={this.props.styles.lbueFill} d="M10.62,7.87c-1.41-1.41-2.08-4.2-2.14-6.14,1.93,2.6,4.45,4.86,7.49,6.14-3.04,1.22-5.44,3.62-7.49,6.14.17-2.07.67-4.59,2.14-6.14Z"/>
                    </g>
                </svg>
                <span className={this.props.styles.delta}>{this.props.delta}</span>
            </span>
        );
    }
}

export const TrendArrow = withStyles(useStyles, TrendArrowWithoutStyles);